// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__34t5q","messages":"Chat_messages__3H9vU","dateDivider":"Chat_dateDivider__1nV7Y"};